import { type RequestPayload, router } from "@inertiajs/core";

import { TermsOfUseForm } from "../../components/termsOfUse/TermsOfUseForm";
import { ContentShell } from "../../layout/ContentShell";
import { public_terms_of_uses_path } from "../../routes";

type TermsOfUseAcceptParent = {
  token: string;
};

export default function TermsOfUseAcceptParent({ token }: TermsOfUseAcceptParent) {
  const onSubmit = (values: RequestPayload) => router.post(public_terms_of_uses_path(), { ...values, token });

  return (
    <ContentShell title="Nutzungsbedingungen" center>
      <TermsOfUseForm onSubmit={onSubmit} />
    </ContentShell>
  );
}
